import accountType from './account-type';
import completed from './completed';
import cvUpload from './cv-upload';
import npiLoading from './npi-loading';
import typeAndCategory from './type-and-category';
import welcome from './welcome';

export default {
  welcome,
  accountType,
  typeAndCategory,
  npiLoading,
  cvUpload,
  completed,
};
